import React from 'react';
import {
  WHATSAPP_EVENT_META,
  WHATSAPP_OPTIONS_KEY,
  mergeWhatsappNotificationSettings,
} from '../../utils/whatsappNotificationSettings.js';

const WhatsAppNotificationSettingsFields = ({
  formData,
  onToggle,
  onFieldChange,
  embedded = false,
}) => {
  if (!formData?.can_access?.whatsapp_notification) {
    return null;
  }

  const settings = mergeWhatsappNotificationSettings(
    formData.can_access?.[WHATSAPP_OPTIONS_KEY]
  );

  return (
    <div>
      {!embedded && (
        <>
          <h3 className="text-base sm:text-md font-semibold text-gray-700 mb-3 sm:mb-4 pb-2 border-b-2 border-grey-400">
            WhatsApp Notification Options
          </h3>
          <p className="text-xs sm:text-sm text-gray-500 mb-3">
            Stored under company can_access. Choose sender / receiver / invoice per event.
            Without invoice uses Utility templates; with invoice uses separate Marketing templates + PDF.
          </p>
        </>
      )}
      {embedded && (
        <p className="text-xs sm:text-sm text-gray-500 mb-3">
          Choose sender / receiver / invoice per event. Without invoice uses Utility templates;
          with invoice uses Marketing templates with Document header PDF.
          Delivery OTP is sent on WhatsApp before Delivered and auto-delivers after verify.
        </p>
      )}
      <div className="space-y-4">
        {WHATSAPP_EVENT_META.map((event) => {
          const checkboxOptions = event.options.filter((option) => option.type !== 'text');
          const textOptions = event.options.filter((option) => option.type === 'text');
          return (
            <div
              key={event.key}
              className="border border-gray-200 rounded-xl p-3 sm:p-4"
            >
              <div className="mb-2">
                <p className="text-sm font-semibold text-gray-800">{event.label}</p>
                <p className="text-xs text-gray-500">{event.hint}</p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
                {checkboxOptions.map((option) => {
                  const checked = Boolean(settings?.[event.key]?.[option.key]);
                  const id = `wa-${event.key}-${option.key}`;
                  return (
                    <label
                      key={option.key}
                      htmlFor={id}
                      className="flex items-center gap-2 p-2 border border-gray-100 rounded-lg hover:bg-gray-50 cursor-pointer"
                    >
                      <input
                        type="checkbox"
                        id={id}
                        checked={checked}
                        onChange={() => onToggle(event.key, option.key)}
                        className="w-4 h-4 text-orange-600 focus:ring-blue-400 border-gray-300 rounded"
                      />
                      <span className="text-xs sm:text-sm text-gray-800">{option.label}</span>
                    </label>
                  );
                })}
              </div>
              {textOptions.map((option) => {
                const id = `wa-${event.key}-${option.key}`;
                const value = settings?.[event.key]?.[option.key] || '';
                return (
                  <div key={option.key} className="mt-3">
                    <label htmlFor={id} className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                      {option.label}
                    </label>
                    <input
                      type="text"
                      id={id}
                      value={value}
                      placeholder={option.placeholder || ''}
                      onChange={(e) => onFieldChange?.(event.key, option.key, e.target.value)}
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:border-orange-400"
                    />
                    {option.placeholder && (
                      <p className="text-[11px] text-gray-500 mt-1">
                        Leave blank to use the default template ({option.placeholder}).
                        Template must be approved on the DigiQin WhatsApp account.
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WhatsAppNotificationSettingsFields;
